import Api from 'libs/api';
import AuthService from 'services/Auth';

class IpraticoApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/ipratico`);
  }
}

export default IpraticoApi;
